/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".wrapper[_ngcontent-%COMP%]{margin-bottom:16px;display:flex;flex-direction:row}.label-text[_ngcontent-%COMP%]{font-weight:700;font-size:10px;line-height:10px;text-transform:uppercase;color:#9da2bd;opacity:.9;width:30%}.value[_ngcontent-%COMP%]{font-size:12px;line-height:12px;color:#1a3349;opacity:.9}"];
export { styles as styles };
